/**
 * Login View
 * Handles user authentication interface
 */

const LoginView = {
    mode: 'login',
    resetToken: null,
    passwordField(id, label, autocomplete) {
        return `<div class="dnr-login-field">
            <label for="${id}">${label}</label>
            <div class="dnr-login-input-wrap">
                <i class="fas fa-lock" aria-hidden="true"></i>
                <input type="password" id="${id}" autocomplete="${autocomplete}" ${autocomplete === 'new-password' ? 'minlength="10"' : ''} required>
                <button type="button" class="dnr-password-toggle" data-password-toggle="${id}" aria-controls="${id}" aria-label="Mostrar ${label.toLowerCase()}" aria-pressed="false"><i class="fas fa-eye" aria-hidden="true"></i></button>
            </div>
        </div>`;
    },
    renderForm() {
        if (this.mode === 'reset') return `
            <h1 class="dnr-login-title">Nueva contraseña</h1>
            <p class="dnr-login-sub">Elige una contraseña de al menos 10 caracteres.</p>
            <form id="recovery-form">
                ${this.passwordField('reset-password', 'Nueva contraseña', 'new-password')}
                ${this.passwordField('reset-confirm', 'Repetir contraseña', 'new-password')}
                <button type="submit" class="dnr-login-submit">Guardar contraseña</button>
            </form>
            <button type="button" class="dnr-login-link" data-login-mode="login">Volver a iniciar sesión</button>`;
        if (this.mode === 'recovery') return `
            <h1 class="dnr-login-title">Recuperar contraseña</h1>
            <p class="dnr-login-sub">Introduce el correo electrónico registrado en tu ficha. Te enviaremos un enlace para cambiar la contraseña.</p>
            <form id="recovery-form">
                <div class="dnr-login-field"><label for="recovery-email">Correo electrónico</label>
                    <div class="dnr-login-input-wrap"><i class="fas fa-envelope" aria-hidden="true"></i><input id="recovery-email" type="email" autocomplete="email" autocapitalize="none" spellcheck="false" maxlength="254" required></div>
                </div>
                <button type="submit" class="dnr-login-submit">Enviar enlace de recuperación</button>
            </form>
            <p class="dnr-login-help">Si ya no tienes acceso a ese correo, contacta con administración.</p>
            <button type="button" class="dnr-login-link" data-login-mode="login">Volver a iniciar sesión</button>`;
        return `
            <h1 class="dnr-login-title">Iniciar sesión</h1>
            <p class="dnr-login-sub">Puedes entrar con tu nombre de usuario o con el correo electrónico registrado en tu ficha.</p>
            <form id="login-form">
                <div class="dnr-login-field"><label for="username">Usuario o correo electrónico</label>
                    <div class="dnr-login-input-wrap"><i class="fas fa-user" aria-hidden="true"></i><input type="text" id="username" placeholder="Usuario o correo" autocomplete="username" autocapitalize="none" spellcheck="false" maxlength="256" required></div>
                </div>
                ${this.passwordField('password', 'Contraseña', 'current-password')}
                <button type="submit" class="dnr-login-submit" id="login-submit-btn">Iniciar sesión</button>
            </form>
            <button type="button" class="dnr-login-link" data-login-mode="recovery">¿Has olvidado tu contraseña?</button>`;
    },
    render() {
        return `
            <div class="dnr-proposal dnr-login">
                <div class="dnr-login-brand">
                    <div class="dnr-login-eyebrow">${Utils.sanitizeHTML(SchoolService.get('name'))}</div>
                    <div class="dnr-login-brand-top">
                        <p class="dnr-login-headline">SICAF</p>
                        <p class="dnr-login-fullname">Sistema Integral de Control Académico y Formación</p>
                        <p class="dnr-login-tagline">Alumnado, docencia, calendario y administración del centro en un solo sitio.</p>
                    </div>
                    <div class="dnr-login-brand-bottom">
                        ${SchoolService.logoHtml('logoLightUrl', 'class="dnr-login-brand-logo"')}
                        <!-- White silhouette of any logo (dark on transparent or on white): alpha = 1 − luminance. -->
                        <svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false"><filter id="sicaf-white-logo" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  -0.2126 -0.7152 -0.0722 1 0"></feColorMatrix></filter></svg>
                    </div>
                </div>

                <div class="dnr-login-form-pane">
                    <div class="dnr-login-form-card" id="login-form-card">
                        ${SchoolService.logoHtml('logoLightUrl', 'class="dnr-login-logo"')}
                        ${this.renderForm()}

                        <div id="login-error" class="dnr-login-error" role="alert">
                            <i class="fas fa-triangle-exclamation" aria-hidden="true"></i>
                            <span id="login-error-text"></span>
                        </div>
                        <p id="recovery-feedback" class="dnr-login-help" role="status" aria-live="polite" hidden></p>

                        <div class="dnr-login-footer">SICAF &middot; ${Utils.sanitizeHTML(SchoolService.label('Plataforma interna'))}</div>
                    </div>
                </div>
            </div>
        `;
    },

    init() {
        document.querySelectorAll('[data-password-toggle]').forEach(button => button.addEventListener('click', () => {
            const input = document.getElementById(button.dataset.passwordToggle);
            const visible = input.type === 'password';
            input.type = visible ? 'text' : 'password';
            button.setAttribute('aria-pressed', String(visible));
            button.setAttribute('aria-label', `${visible ? 'Ocultar' : 'Mostrar'} ${input.labels[0].textContent.toLowerCase()}`);
            button.querySelector('i').className = `fas ${visible ? 'fa-eye-slash' : 'fa-eye'}`;
        }));
        document.querySelectorAll('[data-login-mode]').forEach(button => button.addEventListener('click', () => {
            if (this.busy) return;
            this.resetToken = null;
            this.mode = button.dataset.loginMode;
            SafeHTML.set(document.body, this.render());
            this.init();
            document.querySelector('.dnr-login-form-card input')?.focus();
        }));
        document.getElementById('recovery-form')?.addEventListener('submit', event => this.submitRecovery(event));
        const form = document.getElementById('login-form');
        const card = document.getElementById('login-form-card');
        const errorDiv = document.getElementById('login-error');
        const errorText = document.getElementById('login-error-text');

        if (form) {
            form.addEventListener('submit', async (e) => {
                e.preventDefault();
                const username = document.getElementById('username').value.trim();
                const password = document.getElementById('password').value;

                const btn = document.getElementById('login-submit-btn');
                const originalText = btn.textContent;
                btn.textContent = 'Verificando...';
                btn.disabled = true;
                errorDiv.style.display = 'none';

                let loggedIn = false;

                try {
                    const result = await AuthManager.login(username, password);

                    if (result.success) {
                        loggedIn = true;
                        // Marca para que, tras el reload, App muestre la cortina de apertura
                        // que revela el dashboard ya montado (ver js/app.js).
                        sessionStorage.setItem('ecpv_login_reveal', '1');
                        window.location.reload();
                    } else {
                        throw new Error(result.error || 'Credenciales incorrectas');
                    }
                } catch (error) {
                    errorText.textContent = error.message;
                    errorDiv.style.display = 'flex';
                    card.classList.remove('shake');
                    void card.offsetWidth; // reinicia la animación si el error se repite
                    card.classList.add('shake');
                } finally {
                    // Si el login fue correcto dejamos el botón deshabilitado: la página
                    // está a punto de recargarse y no debe aceptar otro submit mientras tanto.
                    if (!loggedIn) {
                        btn.textContent = originalText;
                        btn.disabled = false;
                    }
                }
            });
        }
    },
    async submitRecovery(event) {
        event.preventDefault();
        if (this.busy) return;
        const feedback = document.getElementById('recovery-feedback');
        const announce = text => { feedback.textContent = text; feedback.hidden = false; };
        const resetting = this.mode === 'reset';
        const password = resetting ? document.getElementById('reset-password').value : null;
        if (resetting && password !== document.getElementById('reset-confirm').value) return announce('Las contraseñas no coinciden. Revisa la confirmación.');
        if (resetting && new TextEncoder().encode(password).length > 72) return announce('La contraseña supera el máximo de 72 bytes. Usa una más corta.');
        this.busy = true;
        const button = event.target.querySelector('button[type="submit"]');
        button.disabled = true;
        announce(resetting ? 'Guardando contraseña…' : 'Solicitando enlace…');
        try {
            const response = await fetch(`/api/password-recovery/${resetting ? 'reset' : 'request'}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json', 'X-SICAF-Request': '1' },
                credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(20000),
                body: JSON.stringify(resetting ? { token: this.resetToken, password } : { email: document.getElementById('recovery-email').value.trim() })
            });
            const result = await response.json();
            if (!response.ok || !result.success) throw new Error(result.error || 'No se pudo completar la operación. Inténtalo de nuevo.');
            announce(result.message);
            event.target.reset();
            if (resetting) {
                this.resetToken = null;
                event.target.hidden = true;
                document.querySelector('[data-login-mode="login"]').focus();
            }
        } catch (error) {
            announce(error instanceof TypeError || error.name === 'TimeoutError' ? 'No se pudo conectar. Comprueba tu conexión y vuelve a intentarlo.' : error.message);
        } finally {
            this.busy = false;
            button.disabled = false;
        }
    }
};

window.LoginView = LoginView;
